/*
 *
 * CheckUserEmail constants
 *
 */

// CHANGE/UPDATE
export const CHANGE_CHECKUSEREMAIL = 'app/CheckUserEmail/CHANGE_CHECKUSEREMAIL';
export const CHANGE_CHECKUSEREMAIL_SUCCESS = 'app/CheckUserEmail/CHANGE_CHECKUSEREMAIL_SUCCESS';
export const CHANGE_CHECKUSEREMAIL_ERROR = 'app/CheckUserEmail/CHANGE_CHECKUSEREMAIL_ERROR';

export const FLUSH_STATE_CHECKUSEREMAIL =
  'app/CheckUserEmail/FLUSH_STATE_CHECKUSEREMAIL';
